export default __webpack_public_path__ + "assets/webgl/picking-12.43b7b779.glb";